import classNames from 'classnames';

import style from './DynamicSVGColor.module.scss';

interface DynamicSVGColorProps {
  icon: string;
  className?: string;
  onClick?: () => void;
}

const DynamicSVGColor = ({ icon, className, onClick }: DynamicSVGColorProps) => {
  return (
    <div
      onClick={onClick}
      className={classNames(style.icon, className)}
      style={{ '--icon-url': `url(${icon})` } as React.CSSProperties}
    />
  );
};

export default DynamicSVGColor;
